import api from "./api";
import { TOKEN_KEY } from "./mw";
import { toast } from "sonner";

export async function openFile(path) {
  const headers = { Authorization: `Bearer ${localStorage.getItem(TOKEN_KEY)}` };
  const tid = localStorage.getItem("mwcrm_tenant"); if (tid) headers["X-Tenant-Id"] = tid;
  const w = window.open("", "_blank");
  const res = await fetch(`${api.defaults.baseURL}${path}`, { headers });
  if (!res.ok) { w?.close(); toast.error("AÇILAMADI"); return; }
  const url = URL.createObjectURL(await res.blob());
  if (w) w.location.href = url; else window.location.href = url;
}

export const waLink = (tel, text) => {
  let n = String(tel || "").replace(/\D/g, "");
  if (n.startsWith("0")) n = "9" + n; else if (n.length === 10) n = "90" + n;
  return `https://wa.me/${n}?text=${encodeURIComponent(text)}`;
};

export async function downloadFile(path, fname) {
  const headers = { Authorization: `Bearer ${localStorage.getItem(TOKEN_KEY)}` };
  const tid = localStorage.getItem("mwcrm_tenant"); if (tid) headers["X-Tenant-Id"] = tid;
  const yr = localStorage.getItem("mwcrm_year"); if (yr) headers["X-Year"] = yr;
  const res = await fetch(`${api.defaults.baseURL}${path}`, { headers });
  if (!res.ok) { toast.error("İNDİRİLEMEDİ"); return; }
  const url = URL.createObjectURL(await res.blob());
  const a = document.createElement("a"); a.href = url; a.download = fname; a.click(); URL.revokeObjectURL(url);
}
